import { createApp } from "vue";
import DoorImage from "./DoorImage.vue";

document.querySelectorAll('[data-vue-root="door-image"]').forEach(el => {
    createApp(DoorImage).mount(el);
});
